import React, { FC, useCallback, useEffect, useState } from 'react';
import { ButtonSizes, SKButton } from '../Button';
import { Loader } from '../../../components';
import { EmptyState, ImageTypes } from '../../../components/EmptyState';
import { SKSwapCard } from '../../../components/SwapKiwi/SwapCard';
import recentSwapsData from '../../../swaps/recent.json';
import cls from 'classnames';
import { ISwap } from '../../../types/swap';

export const RecentPublicSwaps: FC<{ className?: string }> = ({ className }) => {
  const { loading, error, data } = { loading: false, error: false, data: recentSwapsData.swaps as ISwap[] };
  const [swaps, setSwaps] = useState(data);
  const [numberOfSwaps, setNumberOfSwaps] = useState(data.length ?? 0);
  const [currentHistoryOffset, setCurrentHistoryOffset] = useState(0);
  const loadMoreData = (): void => {
    setCurrentHistoryOffset(currentHistoryOffset + 1);
  };
  const getFile = useCallback(async (offset: number) => {
    try {
      const result = await import('../../../swaps/history.json');
      const swaps = result.swaps as ISwap[];
      setSwaps(swaps.slice(0, (offset + 1) * 10));
      setNumberOfSwaps(swaps.length);
    } catch (error) {
      // do a proper action for failure case
      console.log(error);
    }
  }, []);
  useEffect(() => {
    if (currentHistoryOffset >= 1) {
      getFile(currentHistoryOffset);
    }
  }, [currentHistoryOffset]);
  if (loading) {
    return <Loader className={className} />;
  }

  if (!loading && (!data || data?.length === 0)) {
    return (
      <EmptyState
        type={ImageTypes.NONFTS}
        message="No swaps found"
        caption={error ? 'Sorry, an error occurred!' : 'Ready to make a swap?'}
      />
    );
  }

  return (
    <section className={cls('relative bg-onion-50 mx-auto', className)}>
      <h2 className="text-display-lg text-center py-4">Recent Swaps</h2>
      {swaps.map((swap, index) => {
        const parts = [
          {
            addedEther: parseFloat(swap.userEth),
            NFTs: swap.userNFTs,
            walletAddress: swap.fromUser,
          },
          {
            addedEther: parseFloat(swap.offeredEth),
            NFTs: swap.offeredNFTs,
            walletAddress: swap.toUser,
          },
        ];
        const hash = swap.transactionHash;
        return (
          <div
            className={cls(
              'px-2',
              index === numberOfSwaps - 1 ? '' : 'border-b border-cloud-900',
              'py-4',
              index % 2 === 0 ? 'bg-onion-50' : 'bg-onion-100',
            )}
            key={`${swap.contract}--${index}`}
          >
            <SKSwapCard parts={parts} txnHash={hash} swapDate={swap.swapDate} displaySwapTxnDetails />
            {index === swaps.length - 1 && (
              <SKButton className="mx-auto" onClick={(): void => loadMoreData()} color="tertiary" size={ButtonSizes.XL}>
                Load More
              </SKButton>
            )}
          </div>
        );
      })}
    </section>
  );
};
